import { render } from "./BImage.vue?vue&type=template&id=9e0dbb7e&ts=true"
import script from "./BImage.vue?vue&type=script&lang=ts"
export * from "./BImage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__